import { render } from "./client-search.vue?vue&type=template&id=1bc30117"
import script from "./client-search.vue?vue&type=script&lang=js"
export * from "./client-search.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__